import { useMutation } from '@tanstack/react-query'
import { deleteCryptoPayoutById } from 'services/MasspayoutService'

export const useDeleteCryptoRecordMutation = () => {
  return useMutation({
    mutationFn: deleteCryptoPayoutById,
  })
}
